import { render, staticRenderFns } from "./PlayerQueue.vue?vue&type=template&id=44d3be7e&scoped=true&"
import script from "./PlayerQueue.vue?vue&type=script&lang=js&"
export * from "./PlayerQueue.vue?vue&type=script&lang=js&"
import style0 from "./PlayerQueue.vue?vue&type=style&index=0&id=44d3be7e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44d3be7e",
  null
  
)

export default component.exports